import { getAnalytics } from 'common/analytics';

export const unsubscribeRequest = address => {
  getAnalytics().track('Direct Mail Unsubscribe', { address });
};
